import { useCancellationCapabilities } from '@/hooks/queries/cancellations/use-cancellation-capabilities';

import { useCancellationScope } from './use-cancellation-scope';

/**
 * Whether the shell alerts at all, and for whom: Super Admin / Party Admin / Candidate (any
 * role in the list), an election selected, and a valid party. Shared by the alert host and the
 * header bell so the two can never disagree about visibility.
 */
export const useCancellationAlerting = () => {
	const scope = useCancellationScope();
	const eligible = scope.canRead && scope.electionId > 0 && scope.partyResolved;
	const capabilities = useCancellationCapabilities(scope.electionId, eligible);
	return { scope, eligible, capabilities: capabilities.data };
};
